import { ReactNode, useState } from 'react';
import { Container, Row } from 'react-bootstrap';

type Steps = {
  label: string;
  component: ReactNode;
};

type IProps = {
  steps: Steps[];
};

function Tabs({ steps }: IProps) {
  const [activeStep, setActiveStep] = useState(0);

  return (
    <Container fluid>
      <Row className="mb-14">
        <div className="d-flex align-items-center justify-content-center">
          <div className="d-flex p-1 bg-body-secondary rounded-5 flex-wrap">
            {steps?.map((details, index) => (
              <div
                key={`steps-${details.label}`}
                className={`py-2 px-3 mb-0 text-center cursor-pointer ${
                  activeStep === index
                    ? 'bg-gray-1100 rounded-5 text-primary-subtle'
                    : ''
                }`}
                onClick={() => setActiveStep(index)}
              >
                {details.label}
              </div>
            ))}
          </div>
        </div>
      </Row>
      {steps[activeStep].component}
    </Container>
  );
}

export default Tabs;
